import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare var bootstrap: any;

@Component({
  selector: 'app-order-history-customer',
  templateUrl: './order-history-customer.component.html',
  styleUrls: ['./order-history-customer.component.scss'],
  standalone: false

})
export class OrderHistoryCustomerComponent implements OnInit {

  headingName: string = 'Your Order History';
  linkerRouteItems: any[] = [
    { name: 'Home', route: '/home' },
    { name: 'Account', route: '/customer-profile' },
    { name: 'Order History', route: '/customer-order-history' }
  ];

  orderList: any[] = [];
  count: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  isLoading: boolean = false;
  notFoundData: boolean = false;

  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  // Return logic
  selectedOrder: any[] = [];
  returnData = { reason: '', details: '', agree: false };
  returnModal: any;
  showCheckboxes: boolean = false;
  uploadedImages: string[] = []; // ✅ For uploaded images
  selectedImageIndex: number | null = null;

  constructor(
    public commonService: CommonService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.serviceOrderList();

    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 1;
      this.serviceOrderList();
    });

    setTimeout(() => {
      this.returnModal = new bootstrap.Modal(
        document.getElementById('returnPolicyModal')
      );
    }, 500);
  }



  // 🔹 Search input
  onSearchInput(event: any): void {
    const value = event.target.value.trim();
    this.searchTerm = value;
    this.searchSubject.next(value);
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }

  serviceOrderList() {
    this.isLoading = true;
    this.orderList = [];
    this.count = 0;

    const data: any = {
      page: this.currentPage,
      limit: this.pageSize,
      orderType: 'PRODUCT'
    };

    this.commonService.postApi('order/orderListOfOwn', data, 1).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.commonService.hideSpinner();


        if (res['responseCode'] === 200 && res.result.docs.length > 0) {
          let allOrders = res.result.docs;

          if (this.searchTerm) {
            const lowerSearch = this.searchTerm.toLowerCase();
            allOrders = allOrders.filter((order: any) => {
              const productName = order?.productDetails?.[0]?.productId?.productName?.toLowerCase() || '';
              const orderId = order?.orderId?.toLowerCase() || '';
              const deliveryStatus = order?.deliveryStatus?.toLowerCase() || '';
              const orderStatus = order?.orderStatus?.toLowerCase() || '';
              const paymentStatus = order?.paymentStatus?.toLowerCase() || '';
              return (
                productName.includes(lowerSearch) ||
                orderId.includes(lowerSearch) ||
                deliveryStatus.includes(lowerSearch) ||
                orderStatus.includes(lowerSearch) ||
                paymentStatus.includes(lowerSearch)
              );
            });
          }

          allOrders.forEach((order: any) => (order.selected = false));

          this.orderList = allOrders;
          // Use total count from API response, not current page length
          this.count = res.result?.totalDocs || res.result?.count || res.result?.total || this.orderList.length;
          this.notFoundData = this.orderList.length === 0;

          console.log('✅ Final processed orders:', this.orderList.length);
          console.log('📈 Count set to (total from API):', this.count);
          console.log('🔢 Total pages would be:', Math.ceil(this.count / this.pageSize));
          console.log('📋 Order list:', this.orderList);
        } else {
          this.notFoundData = true;
          this.commonService.errorToast(res.responseMessage);
        }
      },
      (err: any) => {
        this.notFoundData = true;
        this.isLoading = false;
        if (err.responseCode === 409) {
          this.commonService.hideSpinner();
          this.commonService.errorToast(err.responseMessage);
        }
      }
    );
  }

  changePageNumber(page: number) {
    this.currentPage = page;
    this.serviceOrderList();
  }

  getNoOfquantity(prodArr: any[]): number {
    return prodArr.reduce((sum, item) => sum + item.quantity, 0);
  }

// ✅ Select All functionality removed - users select items individually
// toggleSelectAll(event: any) {
//   if (!this.showCheckboxes) return;
//   const checked = event.target.checked;

//   // ✅ Sirf DELIVERED items ko select/unselect karo
//   this.orderList.forEach((item: any) => {
//     if (item.deliveryStatus === 'DELIVERED') {
//       item.selected = checked;
//     }
//   });
// }


  anySelected(): boolean {
    return this.orderList.some((item: any) => item.selected);
  }

  toggleReturnMode() {
    this.showCheckboxes = !this.showCheckboxes;
    this.selectedOrder = [];
    this.orderList.forEach((item: any) => (item.selected = false));

    if (this.showCheckboxes) {
      this.commonService.successToast('Now select the items you want to return.');
    } else {
      this.commonService.successToast('Return mode cancelled.');
    }
  }

    toggleItemSelection(item: any) {
    if (item.deliveryStatus !== 'DELIVERED') {
      this.commonService.errorToast('Only delivered products can be returned.');
      return;
    }
    item.selected = !item.selected;
  }

  openReturnPolicyModal() {
    const selectedItems = this.orderList.filter((item: any) => item.selected);
    if (selectedItems.length === 0) {
      this.commonService.errorToast('Please select at least one product to return.');
      return;
    }

    this.selectedOrder = selectedItems;
    this.returnData = { reason: '', details: '', agree: false };
    this.uploadedImages = []; // ✅ reset images
    this.returnModal.show();
  }

// ✅ File select
onFileSelect(event: any) {
  if (event.target.files && event.target.files.length > 0) {
    Array.from(event.target.files).forEach((file: File) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.uploadedImages.push(e.target.result);
      };
      reader.readAsDataURL(file);
    });
  }
}

// ✅ Jab image par click ho, uska index save karo
onImageClick(index: number) {
  this.selectedImageIndex = index;
}

// ✅ Delete only selected image
removeUploadedImage(index: number) {
  this.uploadedImages.splice(index, 1);
}

// ✅ Get Display Status
// ✅ Get Display Status for Customer
getPaymentStatus(item: any): string {
  if (item?.returnRequests?.some(r => r.status === 'APPROVED')) return 'RETURN REQUEST APPROVED';
  if (item?.returnRequests?.some(r => r.status === 'DECLINED')) return 'RETURN REQUEST DECLINED';
  if (item?.returnRequests?.some(r => r.status === 'PENDING')) return 'RETURN REQUEST PENDING';
  return item?.paymentStatus; // fallback to original status
}

// ✅ Get CSS Class for Status
getPaymentStatusClass(item: any): string {
  if (item?.returnRequests?.some(r => r.status === 'APPROVED')) return 'green-color';
  if (item?.returnRequests?.some(r => r.status === 'DECLINED')) return 'red-color';
  if (item?.returnRequests?.some(r => r.status === 'PENDING')) return 'text-danger';
  if (!item?.returnRequests?.length && item?.paymentStatus === 'COMPLETED') return 'green-color';
  return 'red-color';
}



submitReturnForm() {
  if (!this.returnData.reason) {
    this.commonService.errorToast('Please select a reason for return!');
    return;
  }
  if (!this.returnData.agree) {
    this.commonService.errorToast('Please agree to the return policy!');
    return;
  }

  const payload = {
    orderId: this.selectedOrder[0]._id,
    items: this.selectedOrder[0].productDetails.map((p: any) => ({
      itemId: p._id,
      quantity: p.quantity
    })),
    reason: this.returnData.reason,
    additionalInfo: this.returnData.details,
    images: this.uploadedImages,
    acceptedTerms: this.returnData.agree
  };

  this.commonService.postApi('order/returnRequest', payload, 1).subscribe(
    (res: any) => {
      console.log(res); // ✅ Always log the backend response
      if (res.responseCode === 200) {
        this.commonService.successToast(res.responseMessage);
        this.returnModal.hide();

        // ✅ Update payment status locally
        this.selectedOrder.forEach(selectedItem => {
          const index = this.orderList.findIndex(o => o._id === selectedItem._id);
          if (index > -1) {
            this.orderList[index].paymentStatus = 'Return Requested';
          }
        });

        // ✅ Reset form & selection
        this.selectedOrder = [];
        this.returnData = { reason: '', details: '', agree: false };
        this.uploadedImages = [];
        this.showCheckboxes = false;
      } else {
        this.commonService.errorToast(res.responseMessage);
      }
    },
    (err: any) => {
      console.log(err); // ✅ Log error too
      this.commonService.errorToast('Something went wrong. Please try again.');
    }
  );
}



hasDeliveredOrders(): boolean {
  return this.orderList.some(order => order.deliveryStatus === 'DELIVERED');
}



  cancelReturnForm() {
    this.returnModal.hide();
    this.selectedOrder = [];
    this.returnData = { reason: '', details: '', agree: false };
    this.uploadedImages = [];
    this.showCheckboxes = false;
  }

  // Pagination methods - matching customer-product-list
  goToPage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.serviceOrderList();
    }
  }
  
  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const pages: number[] = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  }
  
  getTotalPages(): number {
    return Math.ceil(this.count / this.pageSize);
  }

  getStatusTextClass(status: string): string {
    const lowerStatus = (status || '').toLowerCase();
    // Red for: pending and return request decline
    if (lowerStatus.includes('pending') || 
        (lowerStatus.includes('return request') && lowerStatus.includes('decline'))) {
      return 'status-text--danger';
    }
    // Green for everything else
    return 'status-text--success';
  }
}
